import tw from 'twin.macro'
import { useState } from 'react'
import ArrowRight from '@/icons/bwi/angle-right.svg'
import Collapsible from '@/components/ui/collapsible'

type DisclosureProps = {
  heading: JSX.Element
  children: JSX.Element
  defaultOpen?: boolean
  onClick?: () => void
  ArrowIcon?: (isOpen: boolean) => JSX.Element
}

export default function Disclosure({ heading, children, defaultOpen, onClick, ArrowIcon }: DisclosureProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen)
  return (
    <>
      <button
        type="button"
        tw="flex items-center w-full text-left rounded-full py-1 px-4 hover:(bg-gray-200)"
        onClick={() => {
          onClick?.()
          setIsOpen(!isOpen)
        }}
      >
        {heading}
        {ArrowIcon?.(isOpen) || (
          <ArrowRight css={[tw`w-4 h-4 ml-1 transition-transform flex-none`, isOpen && tw`rotate-90`]} />
        )}
      </button>
      <Collapsible tw="text-sm" isOpen={isOpen}>
        {children}
      </Collapsible>
    </>
  )
}
